<template>
  <div class="copyright">
    <p>Copyright &copy; {{new Date().getFullYear()}} Bakery China Exhibitions Co., Ltd.</p>
  </div>
</template>

<script>
export default {
  name: "copyright"
};
</script>

<style scoped lang="scss">
.copyright {   
  width: 100%;
  margin: 20px;
  color: #aaa;
  font-size: 12px;  
  text-align: center; 
  p {
    opacity: 0.7;
    margin: 0;
  }
}
</style>
